import { Injectable } from '@angular/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { AppUserHomeRequest } from '../SicorService/RequestObject/AppUserHomeRequest';
import { SendIncidenceRequest } from '../SicorService/RequestObject/SendIncidenceRequest';
import { Incidence } from '../../models/Incidence';
import { IncidenceType } from 'src/app/models/IncidenceType';
import { IncidencesRequest } from '../SicorService/RequestObject/IncidencesRequest';
import { NavigationService } from './navigation.service';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { GlobalMethodsService } from '../global-methods.service';
import { ModalController } from '@ionic/angular';
import { AppUserSvrqDownload } from '../SicorService/RequestObject/AppUserSvrqDownload';
import { ModalService } from './modal.service';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MaintenanceService {

  constructor(
    private sicorAPI: SicorApiService,
    private navigation: NavigationService,
    private translate: TranslateConfigService,
    public gms: GlobalMethodsService,
    public modalCtrl: ModalController,
    public modalService: ModalService
  ) { }

  public async getIncidences(requestParams: IncidencesRequest): Promise<Incidence[]> {
    let incidencesList: Incidence[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestIncidences(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null) {
              if (res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'maintenanceModal');
                resolve(undefined);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                if (res.resultSet[0] != null && res.resultSet[0].error != 0) {
                  res.resultSet.forEach(incidence => {
                    let date = new Date();
                    let hour: string;
                    let minutes: string;
                    date.setTime(Date.parse(incidence.crdt));
                    incidence.display_date = date.getDate() + '/' + (date.getMonth() + 1) + '/' + date.getFullYear();
                    date.getHours() < 10 ? hour = '0' + date.getHours() : hour = '' + date.getHours();
                    date.getMinutes() < 10 ? minutes = '0' + date.getMinutes() : minutes = '' + date.getMinutes();
                    incidence.display_hour = hour + ':' + minutes;
                    incidencesList.push(incidence);
                  });
                }
                resolve(incidencesList);
              }
            } else {
              resolve(incidencesList);
            }
          }, error: e => {
            resolve(null);
            this.gms.openFailedProcessModal();
          }
        })
      ));
    });
  }

  public async getIncidenceType(requestParams: AppUserHomeRequest): Promise<IncidenceType[]> {
    let incidenceTypesList: IncidenceType[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestIncidenceTypes(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null) {
              if (res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(false, '', 'maintenanceModal');
                this.modalCtrl.dismiss(null, '', 'reportFailureModal');
                resolve(undefined);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                res.resultSet.forEach(incidenceType => {
                  incidenceTypesList.push(incidenceType);
                });
                resolve(incidenceTypesList);
              }
            }
          }, error: e => {
            resolve(null);
          }
        })
      ));
    });
  }

  public async sendIncidence(requestParams: SendIncidenceRequest): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.sendIncidence(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet[0] != null && res.resultSet[0].error != null) {
              if (res.resultSet[0].error === 401) {
                this.modalCtrl.dismiss(null, '', 'reportFailureModal');
                this.modalCtrl.dismiss(null, '', 'maintenanceModal');
                resolve(undefined);
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else if (res.resultSet[0].error === 0) {
                this.gms.analyticsTrackEvent('fault_event', { eventCategory: 'SICOR/Averia', eventAction: 'Accion/Averia Notificada', eventLabel: requestParams.prbl });
                resolve(true);
              }
              else {
                this.gms.analyticsTrackEvent('fault_event', { eventCategory: 'SICOR/Averia', eventAction: 'Error/Averia Notificada', eventLabel: requestParams.prbl });
                resolve(false);
              }
            }
          }, error: e => {
            this.gms.analyticsTrackEvent('fault_event', { eventCategory: 'SICOR/Averia', eventAction: 'Error/Averia Notificada', eventLabel: requestParams.prbl });
            resolve(null);
          }
        })
      ));
    });
  }

  public async gAppuserSvrqViewDownload(user: string, request_num: number): Promise<string> {
    const requestParams: AppUserSvrqDownload = new AppUserSvrqDownload(user, request_num);
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.gAppuserSvrqViewRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null && res.resultSet[0] != null) {
              if (res.resultSet[0].error != null) {
                if (res.resultSet[0].error === 401) {
                  this.modalService.closeAllOpenModals();
                  await this.navigation.logout();
                  await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                    'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
                  resolve(undefined);
                }
                else {
                  resolve("");
                }
              } else {
                if (res.resultSet[0].s_svrq != null && res.resultSet[0].svrq_pdf != null) {
                  resolve(res.resultSet[0].svrq_pdf);
                }
                else {
                  resolve("")
                }
              }
            } else {
              resolve("");
            }
          }, error: e => {
            resolve("");
          }
        })
      ));
    });
  }
}
